import { Breadcrumbs, IconButton, Typography, Switch, styled } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, matchPath, Navigate, Outlet, useLocation } from "react-router-dom";
import MaterialSymbol from '../../../components/icons/material-symbol';
import { NavLink } from 'react-router-dom';
import productImage from '../../../assets/images/product-img.png';
import { Loading, UserLogin } from "../../../redux/action";
import { InstagramDMAutomation } from "../../../core/services/dm-automation-instagram.service";
import * as gtUtil from "../../../core/utility";
import { toast } from 'react-toastify';
import ContentLoading from "../../../components/loader/loading";
import { UserService } from "../../../core/services";
import CommonPopUpCentered from "../../../components/popup/common-popup-centered";
import { HandlesService } from '../../../core/services/handles.service';

const instagramDMAutomationService: InstagramDMAutomation = new InstagramDMAutomation();
const handlesService = new HandlesService();
const userService = new UserService();
const methods: gtUtil.Methods = new gtUtil.Methods();

interface Props {
  UserReducer: any;
  updateUser: any;
}

// const ExistingAutomation = (props: Props) => {
const ExistingAutomation: React.FC<Props> = (props: Props) => {

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 40,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(24px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#1890ff',
          ...theme.applyStyles('dark', {
            backgroundColor: '#177ddc',
          }),
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
      ...theme.applyStyles('dark', {
        backgroundColor: 'rgba(255,255,255,.35)',
      }),
    },
  }));

  const [popUps, setPopUps] = useState({
    openConnectInstagram: false,
    openAdditionalSettingsModal: false,
    openPermissionMissingModal: false,
    openAutomationDeleteConfirmation: false
  });

  function handleClosePopUps() {
    setPopUps({
      openConnectInstagram: false,
      openAdditionalSettingsModal: false,
      openPermissionMissingModal: false,
      openAutomationDeleteConfirmation: false
    })
  }

  const [loading, setLoading] = useState(false);
  const [social_loader, set_social_loader] = useState<boolean>(false);
  const [instgramAllPermissions, setInstgramAllPermissions] = useState(false)
  const [influencerAccounts, setInfluencerAccounts] = useState<any>([]);
  const [igAutomations, setIgAutomations] = useState<any>([]);
  const [ig_data, set_ig_data] = useState({});
  const [socialRestrictionPopup, set_socialRestrictionPopup] = useState({
    // youtube: false,
    instagram: false
  });
  const [stateToUpdateUserReducer, setStateToUpdateUserReducer] = useState<boolean>(false);
  const [selectedAutomation, setSelectedAutomation] = useState({
    automation_name: '',
    ig_automation_id: 0
  });

  async function updateUserReducer() {
    let latestUserReducerData = await userService.getUpdatedUserReducer(props.UserReducer);
    if (![undefined, null, ''].includes(latestUserReducerData)) {
      props.updateUser(latestUserReducerData)
    }
    // if (props.stateToUpdateUserReducerfuntion) {
    //   props.stateToUpdateUserReducerfuntion(!stateToUpdateUserReducer);
    // }
    setStateToUpdateUserReducer(!stateToUpdateUserReducer);
  }

  const handleOpenConnectInstagramModal = () => {
    if (influencerAccounts?.length < 1) {
      setPopUps({...popUps, openConnectInstagram: true});
    } else if (!instgramAllPermissions) {
      setPopUps({...popUps, openPermissionMissingModal: true});
    } else {
      setPopUps({...popUps, openAdditionalSettingsModal: true});
    }
  }

  // Get all accounts of the influencer
  async function getInfluencerAccounts() {
    try {
      setLoading(true);
      const res = await instagramDMAutomationService.getInfluencerAccounts({
        influencer_id: props.UserReducer.influencer_id,
      });
      
      if (res.status === gtUtil.Constants.SUCCESS) {
        setInfluencerAccounts(res.data.rows);

        // Check permissions only if accounts are present
        if (res.data.rows.length > 0) {
          checkInstagramBusinessPermissions(res.data.rows[0]);
        }
      }
    } catch (error) {
      console.error("Error fetching getInfluencerAccounts:", error);
    } finally {
      setLoading(false);
    }
  }

  // Get all accounts of the influencer
  async function getIgAutomations() {
    try {
      setLoading(true);
      const res = await instagramDMAutomationService.getIgAutomations({
        influencer_id: props.UserReducer.influencer_id,
      });
      
      if (res.status === gtUtil.Constants.SUCCESS) {
        setIgAutomations(res.data.rows);
      }
    } catch (error) {
      console.error("Error fetching getIgAutomations:", error);
    } finally {
      setLoading(false);
    }
  }

  //Function to check all instagram permission are true or not
  function checkInstagramBusinessPermissions(data: any) {
    try {
      // Check if all required properties are true
      const instgramPermissions = 
      // JSON.parse(data?.instagram_business_basic) && JSON.parse(data?.instagram_business_manage_messages) && JSON.parse(data?.instagram_business_manage_comments)
      JSON.parse(data?.instagram_business_basic) && JSON.parse(data?.instagram_business_manage_comments)
      ? true
      : false;
      // const instgramPermissions = 
      // JSON.parse(data?.instagram_business_basic)
      // ? true
      // : false;
      if (instgramPermissions) {
        setInstgramAllPermissions(true);
      } else {
        setInstgramAllPermissions(false);
      }
    } catch (error) {
      console.log('error', error);
      setInstgramAllPermissions(false);
    }
  }

  const instagramConnect = async () => {
    try {
      const response = await handlesService.instagramConnect();
  
      if (response.status === gtUtil.Constants.SUCCESS) {
        // Open Instagram OAuth in a popup window
        const popup = window.open(
          response.data.url,
          "InstagramOAuthPopup",
          "width=500,height=600,left=100,top=100"
        );
  
        if (!popup) {
          toast.error("Popup blocked. Please allow popups and try again.");
          return;
        }
  
        const channel = new BroadcastChannel('oauth-channel');
        channel.onmessage = async (event) => {
          if (event.data?.type === 'social-auth-success') {
            const authCode = event.data.code;
            channel.close();
  
            try {
              set_social_loader(true);
  
              // Send auth code to backend
              const response = await handlesService.postInstagramConnect({
                code: authCode,
                influencer_id: props?.UserReducer?.influencer_id
              });
  
              if (response.status === gtUtil.Constants.SUCCESS) {
                updateUserReducer();
                set_social_loader(false);
                handleClosePopUps();
                setPopUps({...popUps, openAdditionalSettingsModal: true});
              } else {
                if (response.info === 'Social account already connected to the other account.') {
                  set_ig_data(response.data);
                  set_socialRestrictionPopup(prevState => ({
                    ...prevState,
                    instagram: true
                  }));
                }
              }
            } catch (error) {
              console.error("Error processing Instagram auth response:", error);
              toast.error("Instagram authentication failed.");
            } finally {
              set_social_loader(false);
            }
          }
        };
      } else {
        console.error("Error fetching Instagram OAuth URL:", response.info);
        toast.error("Failed to get Instagram authentication URL.");
      }
    } catch (error) {
      console.error("Instagram Login Error:", error);
      toast.error("Instagram login failed");
    } finally {
      set_social_loader(false);
    }
  };

  function handleDeleteAutomation(automation: any) {
    setSelectedAutomation({automation_name: automation.automation_name, ig_automation_id: automation.ig_automation_id});
    setPopUps({...popUps, openAutomationDeleteConfirmation: true});
  }

  async function deleteAutomation(ig_automation_id: number) {
    const response = await instagramDMAutomationService.deleteAutomation({
      ig_automation_id: ig_automation_id
    });

    if (response.status === gtUtil.Constants.SUCCESS) {
      toast.success(response.info);
      getIgAutomations();
      set_social_loader(false);
      handleClosePopUps();
    } else {
      toast.error(response.info);
    }
  }

  async function onOffAutomation(ig_automation_id: number, status: string) {
    const newStatus = (status === 'Live' ? 'Pause' : 'Live');
    const response = await instagramDMAutomationService.onOffAutomation({
      ig_automation_id: ig_automation_id,
      status: newStatus
    });

    if (response.status === gtUtil.Constants.SUCCESS) {
      getIgAutomations();
      toast.success(response.info);
      getIgAutomations();
      set_social_loader(false);
      handleClosePopUps();
    } else {
      toast.error(response.info);
    }
  }

  useEffect(() => {
    getInfluencerAccounts();
    getIgAutomations();
  }, [props.UserReducer.influencer_id])
    
  return (
    <section className='new-automation'>
      <div className='container'>
        <div className='new-automation-top-back'>
          <strong className='me-auto'>
            <Link to={'/influencer/tools/ig-dm-automation'}>
              <MaterialSymbol iconName='chevron_left' fontweight='200' />
            </Link>
            Instagram DM Automation
          </strong>
          <NavLink to='javascript:void(0)' onClick={handleOpenConnectInstagramModal} className='btn btn-primary' >
            New Automation
          </NavLink>
        </div>

        <strong className='automation-existing-page-title'>My Automations</strong>
        <div className='automation-existing'>
          <div className='automation-existing-header'>
            <span className='automation-existing-header-name'>Name</span>
            <span className='automation-existing-header-switch'></span>
            <span className='automation-existing-header-sent'>Sent</span>
            <span className='automation-existing-header-ctr'>CTR</span>
            <span className='automation-existing-header-modified'>Last Modified</span>
            <span className='automation-existing-header-action'></span>
          </div>
          {/* <div className='automation-existing-list'>
            <div className='automation-existing-list-name'>
              <strong>Untitled Automation</strong>
              <div className='automation-existing-list-detail'>
                <span>User comments on <img src={productImage} alt="" /> with keywords</span>
                <ul><li>Price</li><li>link</li><li>pp</li></ul>
              </div>
            </div>
            <span className='automation-existing-list-switch'>
              <AntSwitch  defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
            </span>
            <span className='automation-existing-list-sent'>0</span>
            <span className='automation-existing-list-ctr'>n/a</span>
            <span className='automation-existing-list-modified'>2 days ago</span>
            <span className='automation-existing-list-action'>
              <IconButton className='text-red'>
                <MaterialSymbol iconName='delete' fontweight='200' />
              </IconButton>
            </span>
          </div>
          <div className='automation-existing-list'>
            <div className='automation-existing-list-name'>
              <strong>Untitled Automation</strong>
              <div className='automation-existing-list-detail'>
                <span>User comments on <img src={productImage} alt="" /> with keywords</span>
                <ul><li>Price</li><li>link</li><li>pp</li></ul>
              </div>
            </div>
            <span className='automation-existing-list-switch'>
              <AntSwitch  defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
            </span>
            <span className='automation-existing-list-sent'>0</span>
            <span className='automation-existing-list-ctr'>n/a</span>
            <span className='automation-existing-list-modified'>2 days ago</span>
            <span className='automation-existing-list-action'>
              <IconButton className='text-red'>
                <MaterialSymbol iconName='delete' fontweight='200' />
              </IconButton>
            </span>
          </div> */}
          {
            igAutomations.length > 0 
            ?
            igAutomations.map((automation: any, index: number) => (
              <div className='automation-existing-list' key={automation.ig_automation_id || index}>
                <div className='automation-existing-list-name'>
                  <strong>
                    <Link
                      to={`/influencer/tools/new-automation/${automation.ig_automation_id}`}
                      className='text-muted'
                    >
                      {automation.automation_name || 'Untitled Automation'}
                    </Link>
                  </strong>
                  <div className='automation-existing-list-detail'>
                    <span>User comments on <img src={productImage} alt="" /> with keywords</span>
                    <ul>
                      {(JSON.parse(automation.ig_automation_keywords) || []).map((kw: any, idx: number) => (
                        <li key={idx}>{kw.keyword}</li>
                      ))}
                    </ul>
                  </div>
                </div>
                <span className='automation-existing-list-switch'>
                  {['Live', 'Pause'].includes(automation.status) && (
                    <AntSwitch checked={automation.status === 'Live'} inputProps={{ 'aria-label': 'ant design' }} onChange={() => 
                      {
                        onOffAutomation(automation.ig_automation_id, automation.status)
                      }
                    } />
                  )} 
                  {['Draft'].includes(automation.status) && (
                    // <span className='text-muted'>Draft</span>
                    <Link
                      to={`/influencer/tools/new-automation/${automation.ig_automation_id}`}
                      className='text-muted'
                    >
                      Draft
                    </Link>
                  )}
                  {['Token Expired'].includes(automation.status) && (
                    // <span className='text-muted'>Draft</span>
                    <Link
                      to={`javascript:void(0)`}
                      className='text-muted'
                    >
                      Invalid Token
                    </Link>
                  )}
                </span>
                <span className='automation-existing-list-sent'>0</span>
                <span className='automation-existing-list-ctr'>n/a</span>
                <span className='automation-existing-list-modified'>
                  {methods.calculateDaysDifference(
                    new Date(
                      automation.updated_at
                    ),
                    new Date()
                  )} Days Ago
                </span>
                <span className='automation-existing-list-action'>
                  <IconButton className='text-red' onClick={() => handleDeleteAutomation(automation)}>
                    <MaterialSymbol iconName='delete' fontweight='200' />
                  </IconButton>
                </span>
              </div>
            ))
            :
            <p className="no-list-comment">You have not created any automation yet.</p>
          }
        </div>
      </div>
      <CommonPopUpCentered
        centered
        className={`popup-instagram-automation modal-small  mx-auto`}
        openModal={popUps.openConnectInstagram}
        modalTitle="Connect Instagram"
        modalContent=""
        onClose={() => handleClosePopUps()}
      >
        { 
          social_loader 
          ?
          <ContentLoading width='150' height='150' /> 
          :
          <div className="popup-content">
            <p>Automation requires a connected account. Connect your Instagram account and set your permissions to use the feature.</p>
            <button className="btn btn-primary" onClick={instagramConnect}>Connect</button>
          </div>
        }
      </CommonPopUpCentered>
      <CommonPopUpCentered
        centered
        className={`popup-instagram-automation modal-medium  mx-auto`}
        openModal={popUps.openAdditionalSettingsModal}
        modalTitle="Important Instagram Setting"
        modalContent=""
        onClose={() => handleClosePopUps()}
      >
        <div className="popup-content">
          <p className="text-left">It looks like there's one key setting missing from your Instagram account. To enable Automation, please grant access to Instagram Partner messages.</p>
          <div className="text-left">
            <strong>Here’s how to do it:</strong>
            <ol className="">
              <li>Open your Instagram mobile app.</li>
              <li>{`Go to Menu > Settings and activity > Messages and story replies > Message Controls > Connected Tools.`}</li>
              <li>
                {`Toggle ON ‘Allow access to Messages’.`}</li>
            </ol>
          </div>
          <Link onClick={handleClosePopUps} to="/influencer/tools/new-automation" className="btn btn-primary">It’s Done!</Link>
        </div>
      </CommonPopUpCentered>
      <CommonPopUpCentered
        centered
        className={`popup-instagram-automation modal-small  mx-auto`}
        openModal={popUps.openPermissionMissingModal}
        modalTitle="Permissions Missing"
        modalContent=""
        onClose={() => handleClosePopUps()}
      >
        { 
          social_loader 
          ?
          <ContentLoading width='150' height='150' /> 
          :
          <div className="popup-content">
            <p>It looks like a few permissions are missing. Please either reconnect your account or add new one to proceed.</p>          
            <button className="btn btn-primary" onClick={instagramConnect}>Connect</button>
            <p className="mt-4"><strong>Note:</strong> Connecting a new account will disconnect your currently linked account <strong>Account name</strong> and set the new account as your primary account.</p>
          </div>
        }
      </CommonPopUpCentered>

      <CommonPopUpCentered
        centered
        className={`popup-instagram-automation modal-small  mx-auto`}
        openModal={popUps.openAutomationDeleteConfirmation}
        modalTitle="Confirm"
        modalContent=""
        onClose={() => handleClosePopUps()}
      >
        {
          <div className="popup-content">
            <p>Are you sure you want to delete Automation {selectedAutomation.automation_name}.</p>          
            <button className="btn btn-primary" onClick={() => deleteAutomation(selectedAutomation.ig_automation_id)}>Delete</button>
          </div>
        }
      </CommonPopUpCentered>
    </section>
  )
}
const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
    updateUser: (data: any) => dispatch(UserLogin(data)),
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(ExistingAutomation);

export { connectToRedux as ExistingAutomation };
// export default ExistingAutomation